import { IActivityState } from './interface/IActivityState'

export const initialState: IActivityState = {
  list: undefined,
  categories: undefined,
  metaData: undefined,
}
